const TYPE = {
    ROUND : 'round',
    RECT : 'rect',
    ECLLIPSE : "ellipse",
    TRIANGLE : "triangle",
    OCTAGON : "octa",
    HEX : "exa",
    IMAGE : "image",
    ROUNDRECT : "roundRect"
}

export const DIRECTION = {
    LEFT : 'left',
    RIGHT : 'right',
    BOTTOM : 'bottom',
    TOP : 'top',
}

export default TYPE;